export enum Nodes {
  INVESTORS,
  INVESTMENTS,
}

export const STAGE_TITLE = {
  INVESTORS: 'deal.investors.title',
  INVESTMENTS: 'deal.investments.title',
};
